import { DisclosureSymbolProps } from 'libs/contentful/types';

import { liveUpdateAttrs } from 'libs/contentful/utils';
import { renderSuperscript } from 'utils/superscriptUtils';

const DisclosureSymbol = ({ sys, symbol }: DisclosureSymbolProps) => {
  return (
    <span className="leading-[140%] static" {...liveUpdateAttrs(sys?.id, 'symbol')}>
      {renderSuperscript(symbol)}&nbsp;
    </span>
  );
};
export default DisclosureSymbol;
